<div class="warning {{ color }}" [style.--box-opacity]="opacity">
  <div class="warning__container">
    <img src="{{ icon }}" alt="Ícono" class="warning__container__icon" />
    <p class="warning__container__disclaimer">
      {{ content }}
    </p>
  </div>
</div>
